export default [
  {
    path: '/admin/workstations',
    name: 'admin_workstations',
    component: () => import('./WorkstationsAdmin.vue'),
    meta: {
      name: 'Admin - Vínculo',
    },
  },
]
